import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { zodBrandedString } from '../../utils';
import { MultiPropertyInsuranceFields, PrimaryPropertyInsuranceFields } from './sharedFields/InsuranceFields';

export const CreateEscrowSettingsRow = z.object({
  loanId: zodBrandedString<LosId>(),
  ...PrimaryPropertyInsuranceFields.shape,
  ...MultiPropertyInsuranceFields.shape,
});

export type CreateEscrowSettingsRow = z.infer<typeof CreateEscrowSettingsRow>;

export const CREATE_ESCROW_SETTINGS_ROW_REQUIRED_FIELDS = Object.keys(CreateEscrowSettingsRow.shape).filter(
  (key) => !CreateEscrowSettingsRow.shape[key as keyof typeof CreateEscrowSettingsRow.shape].isOptional(),
) as (keyof CreateEscrowSettingsRow)[];
